import { Injectable } from '@angular/core';
import { ApiService } from '@ps-gui/shared-core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { GutachtenSearchResponse } from '../model/gutachten-search-response.interface';

@Injectable({
  providedIn: 'root',
})
export class ExistingGutachtenRestService extends ApiService {
  protected override get baseUrl(): string {
    return this.backendUrls.psServerUrl;
  }

  searchExistingGutachtenAuftraege(params: HttpParams): Observable<GutachtenSearchResponse> {
    return super.get(`api/v2/gutachten/similar`, { params });
  }
}
